import React, { useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import ContactForm from "../ContactForm";

export default function TitleForm() {
  const navigate = useNavigate();


  const today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1;
  const year = today.getFullYear();
  const hour = today.getHours();
  if (hour > 17) {
    day = (day + 1);
  }
  let maxmonth = (month + 1);
  if (maxmonth < 10) {
    maxmonth = "0" + maxmonth;
  }
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + (day);
  }

  const minDate = `${year}-${month}-${day}`;

  const maxDate = `${year}-${(maxmonth)}-${day}`;

  const [formDataState, setFormDataState] = useState({
    name: "",
    email: "",
    phone: "",
    findUs: "",
    message: "",
    date: minDate
  });

  const [status, setStatus] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendEmail = async (e) => {
    setIsSubmit(true);
    e.preventDefault();

    // Prepare FormData object
    const formData = new FormData();
    formData.append("name", formDataState.name);
    formData.append("email", formDataState.email);
    formData.append("phone", formDataState.phone);
    formData.append("findUs", formDataState.findUs);
    formData.append("message", formDataState.message);
    formData.append("date", formDataState.date);

    try {
      const response = await axios.post("https://entdelhi.com/mailer/mailer.php", formData);
      if (response.data.success) {
        setStatus("Message sent successfully!");
        // Reset form state
        setFormDataState({
          name: "",
          email: "",
          phone: "",
          findUs: "",
          message: "",
        });

        navigate("/thank-you");
      } else {
        setStatus("Failed to send message.");
        console.error(response.data.error);
      }
      setIsSubmit(false);
    } catch (error) {
      setStatus("Something went wrong!");
      console.error("Axios error:", error);
    }
  };
  return (
    <div>
      <section className="about-us">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 px-xl-8 mt-4 mt-xl-0">
              <div className="pq-section pq-style-1 text-left">
                <span className="pq-section-sub-title">Medfirst ENT Centre</span>
                <h1 className="pq-section-title">Our Services</h1>
                <p className="pq-section-description">
                  At MedFirst ENT Centre, we offer expert ENT care under the guidance of Dr. (Major) Rajesh Bhardwaj, a senior ENT specialist in Delhi. We provide treatment for ear problems like hearing loss, infections, tinnitus, and vertigo through modern diagnostic tools and personalized care.<br></br><br></br>
                  Our nasal and sinus services include treatment for sinusitis, allergies, nasal blockage, and polyps. We also perform advanced procedures like septoplasty and FESS to improve breathing and sinus health.<br></br><br></br>
                  For throat issues, we treat sore throats, hoarseness, snoring, sleep apnea, and voice disorders. Surgical solutions like tonsillectomy and adenoidectomy are available when necessary.<br></br><br></br>
                  We also specialize in pediatric ENT care, ensuring child-friendly treatment for common ENT problems. Preventive check-ups, hearing tests, and second opinions before surgery are also available.
                  MedFirst ENT Centre is committed to providing ethical, minimally invasive, and effective ENT care for all age groups.

                </p>
              </div>


            </div>
            <div className="col-xl-4 pe-xl-4">
                <ContactForm />
              {/*<div className="pq-bg-white pq-form-bg-white p-4">
                <div className="pq-applyform-whitebg p-4">
                  <form onSubmit={sendEmail}>
                    <div className="row">
                      <div className="col-md-12">
                        <input
                          min={minDate}
                          max={maxDate}
                          type="date"
                          name="date"
                          placeholder="date"
                          value={formDataState.date}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          value={formDataState.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={formDataState.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="tel"
                          name="phone"
                          placeholder="Phone Number"
                          value={formDataState.phone}
                          onChange={handleChange}
                          required onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="text"
                          name="message"
                          placeholder="Concern"
                          value={formDataState.message}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <select
                          name="findUs"
                          value={formDataState.findUs}
                          onChange={handleChange}
                          required
                        >
                          <option value="" disabled>How did you find us?</option>
                          <option value="youtube">YouTube</option>
                          <option value="instagram-facebook">Instagram/Facebook</option>
                          <option value="google">Google</option>
                          <option value="reference">Reference</option>
                        </select>
                      </div>
                      <div className="col-md-12 pt-2">
                        {!isSubmit && <button type="submit">Book Now</button>}
                        {isSubmit && <button type="submit" disabled={true}>Booking
                          <div class="ms-4 spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                          </div></button>}
                      </div>
                    </div>
                  </form>
                  <p>{status}</p>
                </div>
              </div>*/}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
